<template><WorkspaceView /></template>
<script setup>
import {defineAsyncComponent} from 'vue';
import GameLoading from '../workspace/components/GameLoading.vue';
const WorkspaceView=defineAsyncComponent({loader:()=>import('../workspace/WorkspaceView.vue'),loadingComponent:GameLoading,delay:0});
</script>
